import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

// Shown on tools whose output could be used to size real electrical installations
// (cable, fuse, voltage drop). One wording for all of them; each page passes the
// standards its method is based on. `className` overrides the default spacing/text size
// (placement and size) for pages that show it lower down, e.g. above the guide CTA;
// `showTerms={false}` drops the closing Terms of Service link.
const ToolSafetyDisclaimer = ({ standards, className = 'mb-8 text-sm', showTerms = true }) => (
  <div
    role="note"
    data-testid="tool-safety-disclaimer"
    className={`flex items-start gap-3 rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 leading-relaxed ${className}`}
  >
    <AlertTriangle className="h-5 w-5 shrink-0 text-amber-600 mt-0.5" aria-hidden="true" />
    <p className="text-foreground/80">
      <strong className="text-foreground">Indicative results only — not a substitute for professional design.</strong>{' '}
      This calculator uses simplified methods based on {standards}. Results do not account for
      every installation condition, local regulation, or manufacturer rating. Always verify
      against the current edition of the applicable standard and component datasheets, and
      have safety-critical or high-voltage designs checked by a qualified engineer.
      {showTerms && (
        <>
          {' '}See our <Link to="/terms-of-service" className="text-autoxium-blue font-medium">Terms of Service</Link>.
        </>
      )}
    </p>
  </div>
);

export default ToolSafetyDisclaimer;
